import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import BellImage from '../images/notification_icon.png';

import MenuBar from './../components/Menubar';
import { useUnreadCount } from '../components/UnreadCountContext';

type Props = {
  user: any;
  handleLogin(user: any): void;
};

const ICON_SIZE = 80;
const ICON_GROUP_WIDTH = 180;
const HEADING_MARGIN_LEFT = 150;

type NotificationItem = {
  id: number;
  description: string;
  type: "MEDAL" | "FOLLOWERS_WEEKLY" | "UPVOTES_WEEKLY" | "INITIAL_NOTIFICATION";
  createdAt: string;
  isRead: boolean;
};

const NotifyPage: React.FC<Props> = (props) => {
  const [notifications, setNotifications] = useState<NotificationItem[]>([]);
  const [loading, setLoading] = useState(true);
  const { setNotificationUnread } = useUnreadCount();
  const history = useHistory();

  useEffect(() => {
    if (!props.user?.isLogged)
      return;

    // 1. Fetch notifications
    fetch(process.env.REACT_APP_SERVER_URL + "/notify/all-notifications", {
      headers: {
        Authorization: "Bearer " + props.user.token
      }
    })
      .then(res => res.json())
      .then(data => {
        setNotifications(data || []);
        setLoading(false);
      });

    // 2. Mark ALL as read
    fetch(process.env.REACT_APP_SERVER_URL + "/notify/mark-read-all", {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + props.user.token
      }
    }).then(() => setNotificationUnread(0));

  }, [props.user?.isLogged, props.user?.token]);

  if (!props.user?.isLogged) {
    return <div>Please log in</div>;
  }

  return (
    <main className="main-bg">
      <div className="container mypage">
        <MenuBar user={props.user} />
        <section>
          <div
            className="notify-mobile-wrapper"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              marginTop: '10px',
              marginBottom: '10px',
              position: 'relative',
              width: '100%',
            }}
          >
            <div style={{ width: HEADING_MARGIN_LEFT, flexShrink: 0 }} />

            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-start', paddingLeft:'50px' }}>
              <h1
                style={{
                  fontWeight: 700,
                  fontSize: '2.6rem',
                  margin: 0,
                  letterSpacing: '-1.5px',
                  fontFamily: "'Lulo', 'Montserrat', Arial, sans-serif",
                  lineHeight: 1,
                  userSelect: 'none',
                  textAlign: 'left',
                  marginLeft: '95px',
                }}
              >
                NOTIFICATIONS
              </h1>
            </div>

            <div
              style={{
                width: ICON_GROUP_WIDTH,
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                marginRight: '-45px',
                marginTop: '15px',
                marginBottom: '-1px',
                justifyContent: 'flex-end',
                height: ICON_SIZE,
                flexShrink: 0,
                paddingRight: '50px'
              }}
            >
              <div style={{ position: 'relative', height: ICON_SIZE }}>
                <img
                  src={BellImage}
                  alt="notifications"
                  style={{
                    height: ICON_SIZE,
                    width: ICON_SIZE,
                    objectFit: 'contain',
                    verticalAlign: 'middle',
                    cursor: 'default',
                  }}
                />
              </div>
            </div>
          </div>

          <div
            style={{
              borderBottom: '4px solid #111',
              margin: '18px 0 0 0',
              width: '100%',
            }}
          />

          <div
            style={{
              marginTop: 38,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: '100%',
            }}
          >
            {loading ? (
              <div>Loading...</div>
            ) : notifications.length === 0 ? (
              <div>No recent activity</div>
            ) : (
              <div style={{ width: '100%', maxWidth: 900 }}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 16,
                    maxHeight: '65vh',
                    overflowY: 'auto',
                    paddingRight: 6,
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                  }}
                >
                  {notifications.map((n) => (
                    <div
                      key={n.id}
                      onClick={() => history.push('my-page')}
                      style={{
                        background: '#FFE4DA',
                        padding: '18px 22px',
                        borderRadius: 12,
                        boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
                        borderLeft:
                          n.type === 'MEDAL'
                            ? '6px solid #F6C344'
                            : n.type === 'FOLLOWERS_WEEKLY'
                              ? '6px solid #4FD1C5'
                              : n.type === 'UPVOTES_WEEKLY'
                                ? '6px solid #F56565'
                                : '6px solid #ffffff',
                        cursor: 'pointer',
                        transition: 'transform 0.15s ease, box-shadow 0.15s ease',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.boxShadow = '0 6px 14px rgba(0,0,0,0.12)';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.08)';
                        e.currentTarget.style.transform = 'translateY(0)';
                      }}
                    >
                      <div style={{ fontSize: '1.15rem', fontWeight: 600 }}>
                        {n.description}
                      </div>
                      <div style={{ marginTop: 8, fontSize: '0.9rem', opacity: 0.6 }}>
                        {new Date(n.createdAt).toLocaleString()}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </section>
      </div>
    </main>
  );
};

export default NotifyPage;